import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'

/**
 * Returns villas pricing from cheapest selected package option
 * @returns [totalPrice, value, discount]
 */
function useVillasPrice(
  packageView: App.OfferPackageOptionView,
): [{ hotel: number, member: number }, number, number] {
  const canViewLuxPlusBenefits = useAppSelector((state: App.State) => getCanViewLuxPlusBenefits(state))

  // For consistency, we match how `mapPackageView` derives `hotelDiscountPercent` when computing `value`.
  const [applicableValue, applicableTotal] =
    (packageView.hotelMemberValue > 0 && packageView.hotelMemberTotal > 0 && canViewLuxPlusBenefits) ?
        [packageView.hotelMemberValue, packageView.hotelMemberTotal] :
        [packageView.hotelValue, packageView.hotelTotal]
  const showValue = applicableValue > applicableTotal && packageView.package.shouldDisplayValue
  const showDiscountPill = packageView.hotelDiscountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const value = showValue ? applicableValue : 0
  const discount = showDiscountPill ? packageView.hotelDiscountPercent : 0
  return [
    { hotel: packageView.hotelTotal, member: packageView.hotelMemberTotal },
    value,
    discount,
  ]
}

export default useVillasPrice
